<template>
  <div>
    <section class="tables">
      <div class="row">
        <Breadcrumb :breadcrumbs="breadcrumbs" />

        <div class="col-lg-12">
          <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config"
            :total-rows="total_rows"
            :classes="classes"
            :show-loader="showLoader"
            @on-change-query="onChangeQuery"
          >
            <template slot="action" slot-scope="props">
              <b-dropdown size="xs" variant="primary" text="Select" right>
                <b-dropdown-item @click="viewRow(props.row)">
                  <i class="mdi mdi-eye"></i> View
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="props.row.status === 'Pending'"
                  @click="approveRow(props.row._id)"
                >
                  <i class="mdi mdi-check"></i> Approve
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="props.row.status === 'Pending'"
                  @click="rejectRow(props.row._id)"
                >
                  <i class="mdi mdi-close"></i> Reject
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </vue-bootstrap4-table>

          <b-modal
            ref="refundModal"
            title="Refund Request Details"
            size="lg"
            @hidden="modalView = false"
          >
            <RefundView v-if="modalView" :modalData="modalData" />
          </b-modal>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumb";
import VueBootstrap4Table from "vue-bootstrap4-table";
import RefundView from "./models/view.vue";
import { refundService } from "../../../services/refund.service";
import { mapState } from "pinia";
import { fetchUsers } from "../../../store/fetchUsers.js";

export default {
  name: "RefundRequests",
  components: { Breadcrumb, VueBootstrap4Table, RefundView },

  data() {
    return {
      breadcrumbs: {
        title: "Refund Requests",
        b1: "Manage Refunds",
        b2: "Refund Requests",
        link: false,
      },
      columns: [
        { label: "Name", name: "fullName", sort: true },
        { label: "PNR No", name: "pnr_no", sort: true },
        { label: "Total Refund", name: "totalRefund", sort: true },
        { label: "Route Title", name: "routeTitle", sort: true },
        { label: "Status", name: "status", sort: true },
        { label: "Action", name: "action", sort: false },
      ],
      rows: [],
      total_rows: 0,
      showLoader: false,
      modalView: false,
      modalData: {},
      config: {
        server_mode: false,
        pagination: true,
        global_search: {
          placeholder: "Search refund",
          visibility: true,
        },
        per_page_options: [10, 25, 50],
      },
      classes: { table: "table-bordered table-striped" },
    };
  },

  computed: {
    ...mapState(fetchUsers, ["getUser"]),
  },

  methods: {
    async loadItems() {
      this.showLoader = true;
      const response = await refundService.getAll();
      this.rows = refundService.transform(response);
      this.total_rows = this.rows.length;
      this.showLoader = false;
    },

    viewRow(row) {
      this.modalData = { ...row };
      this.modalView = true;
      this.$nextTick(() => this.$refs.refundModal.show());
    },

    async approveRow(id) {
      const payload = {
        adminId: this.getUser.id,
      };

      const response = await refundService.approve(id, payload);
      this.$toast.open({
        message: "Refund approved & wallet recharged",
        type: "success",
        position: "top-right",
        duration: 3000,
      });
      if (response.status) {
          this.$toast.open({
            message: response.message,
            type: "success",
            position: "top-right",
            duration: 2000,
          });   
      } 
      else {
          this.$toast.open({
            message: "Failed to approved request",
            type: "success",
            position: "top-right",
            duration: 2000,
          });
      }
      this.loadItems();
    },

    async rejectRow(id) {
      const response = await refundService.reject(id);
      if (response.status) {
          this.$toast.open({
            message: response.message,
            type: "success",
            position: "top-right",
            duration: 2000,
          });   
      } 
      else {
          this.$toast.open({
            message: "Failed to approved request",
            type: "success",
            position: "top-right",
            duration: 2000,
          });
      }
      this.loadItems();
    },

    onChangeQuery() {
      this.loadItems();
    },
  },

  mounted() {
    this.loadItems();
  },
};
</script>
